import Vue from 'vue'
import Vuex from 'vuex'

// imports of AJAX functions will go here
import { postChangeServer, authenticate, register } from '@/api'
import { isValidJwt, EventBus } from '@/utils'
import { getServersList } from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    servers_list: [],
    showMessage: false,
    message: '',
    messageType: '',
    user: {},
    jwt: localStorage.getItem('token') || ''
  },

  getters: {
    servers_count: state => {
      return state.servers_list.length
    },
    serversList: state => {
      return state.servers_list
    },
    getShowMessage: (state) => {
      return state.showMessage
    },
    getMessage: (state) => {
      return state.message
    },
    getMessageType: (state) => {
      return state.messageType
    },

    isAuthenticated: (state) => {
      // console.log('is jwt', state.jwt)
      // console.log('is jwt token', state.jwt.token)
      return isValidJwt(state.jwt)
    }
  },

  mutations: {
    set_servers_count_db: (state, payload) => {
      state.servers_count_db = payload
    },
    setServersList: (state, payload) => {
      state.servers_list = payload
    },
    setMessageState: (state, payload) => {
      state.showMessage = payload
    },
    setMessageTxt: (state, payload) => {
      state.message = payload
    },
    setMessageType: (state, payload) => {
      state.messageType = payload
    },

    setUserData: (state, payload) => {
      console.log('setUserData payload = ', payload)
      state.userData = payload.userData
    },
    setJwtToken: (state, payload) => {
      console.log('setJwtToken payload = ', payload)
      localStorage.token = payload.jwt
      state.jwt = payload.jwt
    }
  },

  actions: {
    updateServersList: async (context, failoverIp) => {
      getServersList(context.state.jwt, failoverIp)
        .then((res) => {
          const dataFrom = res.data.servers
          const requestCode = res.data.request_code
          const requestTxt = res.data.request_txt

          if (requestCode === 0) {
            context.commit('setMessageType', 'success')
          } else if (requestCode === 1) {
            context.commit('setMessageType', 'warning')
            context.commit('setMessageState', true)
          } else {
            context.commit('setMessageType', 'danger')
            context.commit('setMessageState', true)
          }

          context.commit('setMessageTxt', requestTxt)
          context.commit('setServersList', dataFrom)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    changeServer (context, data) {
      postChangeServer(context.state.jwt, data)
        .then((res) => {
          const dataFrom = res.data.servers
          const requestCode = res.data.request_code
          const requestTxt = res.data.request_txt

          if (requestCode === 0) {
            context.commit('setMessageType', 'success')
          } else if (requestCode === 1) {
            context.commit('setMessageType', 'warning')
          } else {
            context.commit('setMessageType', 'danger')
          }

          context.commit('setMessageTxt', requestTxt)
          context.commit('setMessageState', true)
          context.commit('setServersList', dataFrom)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    showMessageState (context, state) {
      context.commit('setMessageState', { state })
    },

    login (context, userData) {
      context.commit('setUserData', { userData })
      return authenticate(userData)
        .then(response => context.commit('setJwtToken', { jwt: response.data.token }))
        .catch((error) => {
          // eslint-disable-next-line
          console.log('Error Authenticating: ', error);
          EventBus.$emit('failedAuthentication', error)
        })
    },
    register (context, userData) {
      context.commit('setUserData', { userData })
      return register(userData)
        .then(context.dispatch('login', userData))
        .catch((error) => {
          // eslint-disable-next-line
          console.log('Error Registering: ', error);
          EventBus.$emit('failedRegistering: ', error)
        })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js